/**
 * Calcule le zoom intelligent pour une photo dans un élément donné
 * Utilise la logique sophistiquée originale qui compare les aspect ratios
 * et prend en compte le ratio de zoom de la page
 * 
 * @param imageWidth Largeur originale de l'image en pixels (naturalWidth)
 * @param imageHeight Hauteur originale de l'image en pixels (naturalHeight)
 * @param elementWidth Largeur de l'élément photo en unités workspace (mm)
 * @param elementHeight Hauteur de l'élément photo en unités workspace (mm)
 * @param maxZoom Zoom maximum autorisé (par défaut 300% pour placement manuel)
 * @returns Zoom en pourcentage (100 = taille originale)
 */
export const calculateIntelligentZoom = (
  imageWidth: number,
  imageHeight: number,
  elementWidth: number,
  elementHeight: number,
  maxZoom: number = 300
): number => {
  // Éviter la division par zéro
  if (imageWidth <= 0 || imageHeight <= 0 || elementWidth <= 0 || elementHeight <= 0) {
    return 100;
  }

  // Logique sophistiquée originale : comparer les aspect ratios
  // Si l'image est plus "haute" proportionnellement que l'élément
  if (imageHeight / imageWidth > elementHeight / elementWidth) {
    // L'image est plus "tall" que l'élément, calculer selon la largeur
    const zoom = (((imageHeight / imageWidth) * elementWidth) / elementHeight) * 100;
    return Math.min(zoom, maxZoom);
  } else {
    // L'image est plus "wide" que l'élément, calculer selon la hauteur  
    const zoom = (((imageWidth / imageHeight) * elementHeight) / elementWidth) * 100;
    return Math.min(zoom, maxZoom);
  }
};

/**
 * Version pour le remplissage automatique qui permet un zoom plus élevé
 * Utilise la même logique sophistiquée mais avec limite plus haute pour auto-fill
 */
export const calculateIntelligentZoomWithUpscaling = (
  imageWidth: number,
  imageHeight: number,
  elementWidth: number,
  elementHeight: number
): number => {
  // Utiliser la même logique mais avec un zoom max de 500%
  return calculateIntelligentZoom(imageWidth, imageHeight, elementWidth, elementHeight, 500);
};